module.exports = __webpack_public_path__ + "static/media/strecha.b76a1b38.jpg";